import { useCallback, useState } from 'react'
import { cargarFunctions } from '../lib/firebase'

const mensajesPorCodigo = {
  'functions/invalid-argument': 'Revisa los datos: algo no quedó bien.',
  'functions/resource-exhausted':
    'Ya enviaste varios mensajes seguidos. Espera un momento antes de volver a intentar, o escríbenos por WhatsApp.',
}

/**
 * Envío del formulario de contacto.
 *
 * La validación se repite en la Cloud Function; la de aquí solo existe para
 * dar respuesta inmediata sin gastar una invocación.
 */
export function useContacto() {
  const [estado, setEstado] = useState('inicial') // inicial | enviando | enviado
  const [error, setError] = useState(null)

  const enviar = useCallback(async (datos) => {
    setEstado('enviando')
    setError(null)

    try {
      const { functions, httpsCallable } = await cargarFunctions()
      const recibir = httpsCallable(functions, 'recibirMensajeContacto')
      await recibir(datos)
      setEstado('enviado')
      return true
    } catch (err) {
      console.error('useContacto:', err)
      setEstado('inicial')
      setError(
        mensajesPorCodigo[err.code] ??
          'No pudimos enviar el mensaje. Escríbenos por WhatsApp mientras lo revisamos.'
      )
      return false
    }
  }, [])

  return { enviar, estado, error }
}
